import { useMemo } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
const BASE_URL = 'automationapps/v1';
export const GET_FLOWS_FIELD_NAME = 'flows';
export const GET_FLOWS = registerQuery({
  fieldName: GET_FLOWS_FIELD_NAME,
  args: ['guid', 'sourceApp'],
  fetcher({
    guid,
    sourceApp
  }) {
    const portalId = PortalIdParser.get();
    return http.get(`${BASE_URL}/summaries`, {
      query: {
        portalId,
        platformSourceApps: sourceApp,
        uuid: `${portalId}:${guid}`
      }
    }).then(({
      results
    }) => results);
  }
});
export function useFetchFlows({
  guid,
  sourceApp
}) {
  const {
    data,
    error,
    loading
  } = useQuery(GET_FLOWS, {
    variables: {
      guid,
      sourceApp
    },
    fetchPolicy: 'network-only'
  });
  return useMemo(() => ({
    data: data && data[GET_FLOWS_FIELD_NAME],
    error,
    loading
  }), [data, error, loading]);
}